import {useEffect, useState} from 'react'
import {DebounceInput} from 'react-debounce-input'
import {useIntl} from 'react-intl'

import ItemList from '../component/List'
import {BreadCrumb} from 'src/_metronic/layout/components'
import {useGetList} from '../context/useQuery'
import {useUploadItem} from '../context/useMutation'
import {useItem} from '../hook'
import {toast} from 'react-toastify'
import {useRef} from 'react'
import {useIsMobile} from 'src/feature/bite/hook/useIsMobile'

function Dashboard() {
  const intl = useIntl()
  const {listFilter, listFilterSet} = useItem()
  const {isLoading, refetch} = useGetList()
  const {mutateAsync: uploadItem, isLoading: isUploadingItem} = useUploadItem()
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('1')
  const {list} = useItem()
  const hiddenFileInput = useRef(null)
  const isMobile = useIsMobile()

  useEffect(() => {
    if (listFilter.filterList.length > 0) {
      const searchFilter = listFilter.filterList.find((x) => x.key === 'nm')

      if (searchFilter) {
        setSearch(searchFilter.value[0])
        // setBadges([{ key: 'search', value: searchFilter.value[0] }])
      }
    }
  }, [])

  const handleUpload = async (file: File) => {
    const data = await uploadItem(file)
    return data
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <BreadCrumb currentPage={intl.formatMessage({id: 'MENU.PRODUCT'})} />
      <div>
        <h3 className='text-dark fw-bolder mt-10 mb-2'>Products</h3>
        <p className='text-muted fs-6'>
          This section displays a list of all products you've created. You can search, manage, and
          add products as needed. Products listed here are displayed in the Store section of the
          Vasco Life App.
        </p>
      </div>
      <div className='d-flex flex-column flex-root' id='kt_app_root'>
        <div className='card mt-10'>
          <div className='card-header border-0 pt-6'>
            <div className='card-title w-100 w-md-auto'>
              <div className='d-flex align-items-center position-relative my-1 w-100 w-md-auto'>
                <i className='ki-outline ki-magnifier fs-3 position-absolute ms-5'></i>
                <DebounceInput
                  debounceTimeout={500}
                  type='text'
                  className='form-control form-control-solid w-100 w-sm-500px ps-13'
                  placeholder={intl.formatMessage({
                    id: 'GLOBAL.FILTER.SEARCH.SUBSCRIPTION_PACKAGE_ITEM',
                  })}
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value)
                    listFilterSet({
                      ...listFilter,
                      paging: {
                        ...listFilter.paging,
                        currentPageNumber: 1,
                      },
                      filterList: [
                        {
                          key: 'nm',
                          operator: 14,
                          logicalOp: 2,
                          value: [e.target.value],
                          childFilters: [
                            {
                              key: 'SkuID',
                              operator: 14,
                              logicalOp: 2,
                              value: [e.target.value],
                              childFilters: [],
                            },
                            {
                              key: 'brcd',
                              operator: 14,
                              logicalOp: 2,
                              value: [e.target.value],
                              childFilters: [],
                            },
                          ],
                        },
                        // {
                        //   key: 'stts',
                        //   value: [status],
                        //   operator: 1,
                        //   logicalOp: 2,
                        // },
                        ...(status !== '1'
                          ? [{key: 'stts', value: [status], operator: 1, logicalOp: 2}]
                          : []),
                      ],
                    })
                  }}
                />
              </div>
            </div>
            {!isMobile && (
              <div className='card-toolbar'>
                <div
                  className='d-flex justify-content-end gap-5'
                  data-kt-customer-table-toolbar='base'
                >
                  <div className='d-flex flex-column gap-3'>
                    <input
                      type='file'
                      accept='.xls,.xlsx'
                      onChange={async (e) => {
                        if (e.target.files && e.target.files.length > 0) {
                          if (e.target.files[0].name.split('.').pop() !== 'xlsx') {
                            toast.error(intl.formatMessage({id: 'GLOBAL.FILE.TYPE.ERROR'}))
                            return
                          }
                          handleUpload(e.target.files[0])
                        }
                      }}
                      ref={hiddenFileInput}
                      style={{display: 'none'}} // Make the file input element invisible
                    />
                    <button
                      type='button'
                      disabled={isUploadingItem}
                      className='btn btn-primary rounded'
                      onClick={() => {
                        // @ts-ignore
                        hiddenFileInput.current.click()
                      }}
                    >
                      {isUploadingItem ? (
                        <>
                          <div className='spinner-border spinner-border-sm' role='status'>
                            <span className='visually-hidden'>Uploading...</span>
                          </div>
                          <span className='ms-2'>Uploading...</span>
                        </>
                      ) : (
                        <>
                          <i className='fa fa-upload me-3'></i>
                          {intl.formatMessage({id: 'GLOBAL.ITEMS.UPLOAD.XLSX'})}
                        </>
                      )}
                    </button>
                  </div>

                  <a href='/items/new-item' className='btn btn-primary'>
                    <i className='fa fa-plus me-3'></i>
                    Add New Product
                  </a>
                </div>
              </div>
            )}
          </div>
          <div className='card-body pt-5 pt-sm-10'>
            <ItemList loading={isLoading} list={list} refetch={refetch} />
          </div>
        </div>
      </div>
    </>
  )
}

export default Dashboard
